import React from 'react';
import classNames from 'classnames';
import { DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
import { Typography } from "../Typography/Typography";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: 40,
        padding: 0,
        backgroundColor: theme.palette.primary.main,
    },
    titleText: {
        lineHeight: '40px',
        color: theme.palette.dark.text.primary,
    },
}); }, { name: 'SnDialogTitle' });
/**
 * ダイアログタイトルコンポーネント。
 */
export var DialogTitle = function (props) {
    var classes = useStyles(props);
    return (React.createElement(MuiDialogTitle, { className: classNames(classes.root, props.className), style: props.style },
        React.createElement(Typography, { variant: "body1", align: "center", className: classes.titleText }, props.children)));
};
